<div class="grid-body">
  <kl-form-entry-grid
    [gridName]="'grdProductLicenseLine'"
    [moduleName]="'PRODUCT_LICENSE_HISTORY_FORM'"
    [parentModuleName]="'MATERIAL_MANAGEMENT'"
    [allowResizing]="'Both'"
    [viewableRowCount]="10"
    [deferResizing]="false"
    [collectionView]="itemsSource"
    [selectionColumn]="2"
    [isReadOnly]="true"
    [columns]="[
      {
        header: 'created_date' | translate,
        binding: 'created_date',
        width: 150,
        visible: false,
        format: 'date-time'
      },
      {
        header: 'installation_user' | translate,
        binding: 'installation_user.username',
        width: '*',
        visible: false
      },
      {
        header: 'terminal_id' | translate,
        binding: 'terminal_id',
        width: '*',
        visible: false
      },
      {
        header: 'license_key' | translate,
        binding: 'product_license.license_key',
        width: '*',
        visible: false
      }
    ]"
  >
  </kl-form-entry-grid>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default btn-sm"
      data-dismiss="modal"
      (click)="klModal.closeModal()"
    >
      {{ "close" | translate }}
    </button>
  </div>
</div>
